module.exports = __webpack_public_path__ + "static/media/blue-background-tick.5d9c5742.png";